import(/* webpackMode: "eager", webpackExports: ["WebVisualizer"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/WebVisualizer.tsx");
